import { SectionTitle } from "./SectionTitle";
import { motion } from "framer-motion";
import { fadeUp, staggerContainer, viewportOnce } from "@/lib/animations";
import {
  ShieldCheck,
  TrendingUp,
  Truck,
  RefreshCw,
  Gem,
  BadgeCheck,
} from "lucide-react";

const features = [
  {
    icon: <Gem className="h-6 w-6" />,
    title: "German Silver Jewellery",
    description:
      "Every ring is crafted from German silver — guaranteed quality, carefully verified before dispatch.",
  },
  // {
  //   icon: <TrendingUp className="h-6 w-6" />,
  //   title: "Live Market Pricing",
  //   description:
  //     "Our prices are updated daily based on official Indian silver spot rates. You always pay a fair, transparent price.",
  // },
  {
    icon: <BadgeCheck className="h-6 w-6" />,
    title: "Quality Certified",
    description:
      "Each piece undergoes strict quality checks. The purity and finish are clearly stated on every product page.",
  },
  {
    icon: <Truck className="h-6 w-6" />,
    title: "Free Insured Delivery",
    description:
      "All orders are shipped in tamper-proof packaging with full insurance. Free delivery on orders above ₹999.",
  },
  // {
  //   icon: <RefreshCw className="h-6 w-6" />,
  //   title: "7-Day Easy Returns",
  //   description:
  //     "Not happy with your order? Return it within 7 days for a full refund — no questions asked.",
  // },
  // {
  //   icon: <ShieldCheck className="h-6 w-6" />,
  //   title: "Secure Payments",
  //   description:
  //     "256-bit SSL encryption on all transactions. We support UPI, cards, net banking, and EMI with zero extra charge.",
  // },
];

export function FeaturesSection() {
  return (
    <section id="features" className="py-10 md:py-14 lg:py-16">
      <div className="wrapper">
        <motion.div
          className="mb-10 md:mb-12"
          variants={fadeUp}
          initial="hidden"
          whileInView="visible"
          viewport={viewportOnce}
        >
          <SectionTitle
            badge="WHY SMORA"
            title="Why Choose Our Silver Rings?"
            subtitle="Quality, purity, and transparency at every step — from mine to your finger."
            centered
          />
        </motion.div>

        <motion.div
          className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6"
          variants={staggerContainer}
          initial="hidden"
          whileInView="visible"
          viewport={viewportOnce}
        >
          {features.map((feature, i) => (
            <motion.div
              key={i}
              variants={fadeUp}
              className="group bg-background border border-border rounded-2xl p-6 hover:border-primary/40 hover:shadow-lg transition-all duration-300"
            >
              <div className="w-12 h-12 rounded-xl bg-primary/10 flex items-center justify-center text-primary mb-4 group-hover:bg-primary group-hover:text-white transition-colors duration-300">
                {feature.icon}
              </div>
              <h3 className="text-base font-semibold text-foreground mb-2">
                {feature.title}
              </h3>
              <p className="text-sm text-muted-foreground leading-relaxed">
                {feature.description}
              </p>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
}
